// Mutations
export const SET_ASSETS_MATURITY = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.assetsMaturity.data = payload
    state.assetsMaturity.lastUpdate = new Date()
  }
}
export const ADD_ASSETS_MATURITY = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.assetsMaturity.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.assetsMaturity.data.push(data)
      }
    })
  }
}
export const SET_ASSETS_MATURITY_LOADING = (state, payload) => {
  state.assetsMaturity.loading = payload
}

export const SET_ASSETS_APPROACHING = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.assetsApproaching.data = payload
    state.assetsApproaching.lastUpdate = new Date()
  }
}
export const ADD_ASSETS_APPROACHING = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach((data) => {
      let old = state.assetsApproaching.data.find((item) => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.assetsApproaching.data.push(data)
      }
    })
  }
}
export const SET_ASSETS_APPROACHING_LOADING = (state, payload) => {
  state.assetsApproaching.loading = payload
}
export const SET_EXPORT_TAXES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.exportTaxes.data = payload
    state.exportTaxes.lastUpdate = new Date()
  }
}
export const ADD_EXPORT_TAXES = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.exportTaxes.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.exportTaxes.data.push(data)
      }
    })
  }
}
export const SET_EXPORT_TAXES_LOADING = (state, payload) => {
  state.exportTaxes.loading = payload
}

export const SET_CARTEIRA_ADMINISTRADA = (state, payload) => {
  if (payload && typeof payload === 'object') {
    state.carteiraAdministrada.data = payload
    state.carteiraAdministrada.lastUpdate = new Date()
  }
}
export const ADD_CARTEIRA_ADMINISTRADA = (state, payload) => {
  if (payload && typeof payload === 'object') {
    let dados = JSON.parse(JSON.stringify(payload))
    if (!Array.isArray(dados)) {
      dados = [dados]
    }
    dados.forEach(data => {
      let old = state.carteiraAdministrada.data.find(item => item.id === data.id)
      if (old) {
        Object.keys(data).forEach((key) => {
          old[key] = data[key]
        })
      } else {
        state.carteiraAdministrada.data.push(data)
      }
    })
  }
}
export const SET_CARTEIRA_ADMINISTRADA_LOADING = (state, payload) => {
  state.carteiraAdministrada.loading = payload
}

